export default __webpack_public_path__ + "images/c971cb211e358cd3fad229045141afa2-biddulph.png";